import MemorialPageDetail from "../../../components/Memorial/MemorialPageDetail";
import api from "../../../lib/api";

export default function Memorial({ memorialsData, slug }) {
  return <MemorialPageDetail data={memorialsData} slug={slug} />;
}

export async function getStaticPaths() {
  const memorials = await api.getContent("/api/memorials");
  // console.log("Memorials:", memorials);
  const locations = memorials.map((location) => location.slug);

  const pathsDe = locations.map((slug) => ({
    params: { slug },
    locale: "de",
  }));
  const pathsEn = locations.map((slug) => ({
    params: { slug },
    locale: "en",
  }));

  return { paths: [...pathsDe, ...pathsEn], fallback: "blocking" };
}

export async function getStaticProps({ params, locale }) {
  const slug = params.slug;
  let memorialsData = await api.getContent(`/api/memorials`, {
    locale,
  });

  if (!memorialsData.find((element) => element.slug === slug)) {
    return { notFound: true };
  }

  memorialsData = memorialsData.sort((a, b) => {
    const titleA = a.title.toUpperCase();
    const titleB = b.title.toUpperCase();

    if (titleA < titleB) return -1;
    if (titleA > titleB) return 1;
    return 0;
  });

  return await api.injectDefaultData(
    {
      props: { memorialsData, slug },
      revalidate: 3,
    },
    locale,
  );
}
